<template lang="pug">

div

    //- Navigation
    navigation

    //- Headline
    //- .ui.attached.segment
    //-     .ui.two.column.centered.middle.aligned.grid
    //-         .column
    //-             h2.ui.header
    //-                 i.building.icon
    //-                 .content Unternehmen
    //-         .ui.form.column
    //-             input(type='text' placeholder='Ihr Suchbegriff')

    //- Typ-Filter
    .ui.secondary
        .ui.labels
            router-link.ui.label(v-bind:to='{ name: "companies" }' exact)
                | Alle:
                .ui.detail {{ counts.all }}
            router-link.ui.label(v-bind:to='{ name: "companies", query: { filter: "PURCHASER" }}' exact)
                | Auftraggeber:
                .ui.detail {{ counts.purchaser }}
            router-link.ui.label(v-bind:to='{ name: "companies", query: { filter: "SUPPLIER" }}' exact)
                | Lieferant:
                .ui.detail {{ counts.supplier }}
            router-link.ui.label(v-bind:to='{ name: "companies", query: { filter: "AGENCY" }}' exact)
                | Agentur:
                .ui.detail {{ counts.agency }}

    //- Message wenn keine Unternehmen gefunden
    .ui.icon.message(v-if='companies.length === 0')
        i.meh.icon
        .content: .header Keine Unternehmen gefunden

    template(v-else)

        //- Unternehmen
        companies-table.ui.segment(
            v-bind:address-models='addressModels'
            v-bind:company-models='companies'
        )

        //- Pagination
        .ui.bottom.secondary
            .ui.two.column.grid
                .middle.aligned.column
                    .ui.form
                        .inline.fields(style='margin: 0')
                            label Zeilen pro Seite:
                            .field
                                select.ui.selection.dropdown(ref='pageSizeDropdown')
                                    option(v-for='n in pageSizeOptions' v-bind:key='n' v-bind:value='n') {{ n }}
                .right.aligned.middle.aligned.column(v-if='totalPages > 1')
                    .ui.pagination.menu
                        a.icon.item(v-bind:class='{ disabled: currentPage === 1 }' v-on:click='currentPage > 1 && (currentPage -= 1)')
                            i.left.chevron.icon
                        a.item(
                            v-for='page in totalPages'
                            v-bind:key='page'
                            v-bind:class='{ active: page === currentPage }'
                            v-on:click='currentPage = page'
                        ) {{ page }}
                        a.icon.item(v-bind:class='{ disabled: currentPage === totalPages }' v-on:click='currentPage < totalPages && (currentPage += 1)')
                            i.right.chevron.icon

</template>

<script>
    import store from '@/store'
    import Navigation from '@/components/companies/Navigation.vue'
    import CompaniesTable from '@/components/companies/Table.vue'

    async function load_page($route, { page = 0, size = 20 } = {}) {
        const type = $route.query.filter
        const companies = await store.dispatch('companies/loadPage', { page, size, type })
        await Promise.all(
            companies
                .map(c => c.defaultBillingAddress)
                .filter(Boolean)
                .map(id => store.dispatch('addresses/loadOne', { id }).catch(() => null))
        )
        return companies
    }

    //noinspection JSUnusedLocalSymbols,JSUnusedGlobalSymbols
    export default {

        beforeRouteEnter(to, from, next) {
            load_page(to).then(companies => next(vm => { vm.pageCompanies = companies }))
        },

        beforeRouteUpdate(to, from, next) {
            this._routeChanging = true
            this.currentPage = 1
            load_page(to, { size: this.itemsPerPage })
                .then(companies => {
                    this.pageCompanies = companies
                    this._routeChanging = false
                    next()
                })
        },

        components: { CompaniesTable, Navigation },

        created() {
            this._routeChanging = false
        },

        mounted() {
            this._initDropdown()
        },

        updated() {
            this._initDropdown()
        },

        data() {
            return {
                currentPage: 1,
                itemsPerPage: 25,
                pageCompanies: [],
                pageSizeOptions: [25, 50, 100, 250],
            }
        },

        watch: {
            currentPage() {
                if (!this._routeChanging) {
                    this.loadCurrentPage()
                }
            },
            itemsPerPage() {
                if (this.currentPage === 1) {
                    this.loadCurrentPage()
                } else {
                    this.currentPage = 1
                }
            },
        },

        methods: {
            _initDropdown() {
                const el = this.$refs.pageSizeDropdown
                if (!el || $(el).data('module-dropdown')) return
                $(el).dropdown({
                    onChange: (value) => {
                        const n = parseInt(value, 10)
                        if (n !== this.itemsPerPage) {
                            this.itemsPerPage = n
                            this.currentPage = 1
                        }
                    }
                })
            },

            async loadCurrentPage() {
                const type = this.$route.query.filter
                const companies = await store.dispatch('companies/loadPage', {
                    page: this.currentPage - 1,
                    size: this.itemsPerPage,
                    type,
                })
                await Promise.all(
                    companies
                        .map(c => c.defaultBillingAddress)
                        .filter(Boolean)
                        .map(id => store.dispatch('addresses/loadOne', { id }).catch(() => null))
                )
                this.pageCompanies = companies
            }
        },

        computed: {

            counts() {
                return store.getters['companies/counts']
            },

            addressModels() {
                return store.getters['addresses/all']
            },

            companies() {
                return this.pageCompanies
            },

            totalPages() {
                const type = this.$route.query.filter
                const c    = this.counts
                const total = type === 'PURCHASER' ? c.purchaser
                            : type === 'SUPPLIER'  ? c.supplier
                            : type === 'AGENCY'    ? c.agency
                            : c.all || 0
                return Math.ceil((total || 0) / this.itemsPerPage)
            },

        }

    }

</script>
